import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MaterialModule} from '../material';
// import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { UserDashboardComponent } from './user-dashboard.component';
import { SocialMediaAccountsComponent } from './social-media-accounts/social-media-accounts.component';
import { ProfileComponent } from './profile/profile.component';
import { PaymentHistoryComponent } from './payment-history/payment-history.component';
import { UserHomeComponent } from './user-home/user-home.component';
import { BusinessInfoComponent } from './business-info/business-info.component';
import { EventsComponent } from './events/events.component';
import { contentchannel } from './social-media-accounts/social-media-accounts.component';
import { MatIconModule } from '@angular/material/icon';
import { ManageBusinessComponent } from './manage-business/manage-business.component';
import { MatTableModule} from '@angular/material/table';
import { EditBusinessinfoComponent } from './edit-businessinfo/edit-businessinfo.component';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { PaymentstatusComponent } from './paymentstatus/paymentstatus.component';
import { ToastrModule } from 'ngx-toastr';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { PermisssionDetailsDialog, RequestListComponent } from './request-list/request-list.component';
import { DeleteDialog } from './manage-business/manage-business.component';
import { DeleteAccountDialog } from './social-media-accounts/social-media-accounts.component';
import { ShowEvents } from './events/events.component';
import { AIComponent } from './ai/ai.component';
import { EmailOtpDialog } from './profile/profile.component';
import { AnalyticsComponent } from './analytics/analytics.component';
import { AdsManagerComponent } from './ads-manager/ads-manager.component';


@NgModule({
  declarations: [
    UserDashboardComponent,
    SocialMediaAccountsComponent,
    ProfileComponent,
    PaymentHistoryComponent,
    UserHomeComponent,
    BusinessInfoComponent,
    EventsComponent,
    contentchannel,
    ManageBusinessComponent,
    EditBusinessinfoComponent,
    PaymentstatusComponent,
    RequestListComponent,
    PermisssionDetailsDialog,
    DeleteDialog,
    DeleteAccountDialog,
    ShowEvents,
    AIComponent,
    EmailOtpDialog,
    AnalyticsComponent,
    AdsManagerComponent
  ],
  imports: [
    CommonModule,BrowserAnimationsModule,BrowserModule,
    RouterModule,
    MaterialModule,
    MatIconModule,
    MatTableModule,
    FormsModule,
    ImageCropperComponent,
    ReactiveFormsModule.withConfig({ warnOnNgModelWithFormControl: 'never' }),
    ToastrModule.forRoot({
      positionClass: 'toast-bottom-right', 
      preventDuplicates: true,
      timeOut: 1000,  
  extendedTimeOut: 500,  
  progressBar: true,  

    }),
  ],
  providers: [
    DatePipe,PermisssionDetailsDialog
  ]
})
export class  UserDashboardModule { }